import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryTitleGray } from '../../../app/theme/tokens/colors';
import { useSalesStore } from '../store/salesStore';
import { useSuballocationStore } from '../store/suballocationStore';
import { DefaultFinishOrder } from '../../orders/usecases/finish/defaultFinishOrder';
import { usePortalStore } from '../../../stores/portalStore';
import { saveSalesOrder } from '../../../services/orders/orderService';
import { saveSuballocationOrder } from '../../../services/orders/orderService';

const ProductOrderFinish = ({ storeHook, orderType, selectPatientPath, catalogPath, onSave }) => {
    const selectedPatient = storeHook((state) => state.selectedPatient);
    const cart = storeHook((state) => state.cart);
    const currentUser = usePortalStore((state) => state.currentUser);
    const navigate = useNavigate();

    useEffect(() => {
        if (!selectedPatient) navigate(selectPatientPath);
        else if (cart.length === 0) navigate(catalogPath);
    }, [cart.length, catalogPath, navigate, selectPatientPath, selectedPatient]);

    if (!selectedPatient || cart.length === 0) return null;

    const finishOrder = async (deliveryDate, deliveryTurn) => {
        return onSave(currentUser, selectedPatient, cart, deliveryDate, deliveryTurn);
    };

    const orderItems = () => (
        <div>
            <h3 style={{ color: PrimaryTitleGray, marginTop: 0 }}>Itens selecionados</h3>
            {cart.map((item) => (
                <div key={item.lineId} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 0', borderBottom: '1px solid #ececec' }}>
                    <img src={item.image} alt="" style={{ width: '68px', height: '58px', objectFit: 'cover', borderRadius: '6px' }} />
                    <div style={{ flex: 1 }}>
                        <strong style={{ color: PrimaryTitleGray }}>{item.name}</strong>
                        <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '7px', color: '#666', marginTop: '5px' }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', minHeight: '24px', padding: '0 9px', border: '1px solid #d7d7d7', borderRadius: '999px', background: '#f5f5f5', color: '#626262', fontSize: '12px', fontWeight: 700 }}>{item.sku}</span>
                            <span>Quantidade: {item.quantity}</span>
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );

    return <DefaultFinishOrder selectedPatient={selectedPatient} topTileRender={orderItems} onFinish={finishOrder} orderType={orderType} fastDeliveryLabel="Entrega imediata" scheduleDeliveryLabel="Entrega agendada" hasFastDelivery={true} />;
};

export const FinishSalesOrder = () => (
    <ProductOrderFinish storeHook={useSalesStore} orderType="Descartáveis" selectPatientPath="/sales/selectPatient" catalogPath="/sales/catalog" onSave={saveSalesOrder} />
);

export const FinishSuballocationOrder = () => (
    <ProductOrderFinish storeHook={useSuballocationStore} orderType="Sublocação" selectPatientPath="/suballocation/selectPatient" catalogPath="/suballocation/catalog" onSave={saveSuballocationOrder} />
);
